import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { url } from "@recoil/Store";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import Main from "../../Main";
import DOMPurify from "dompurify";
export default function Products(props) {
    const [urls, setUrl] = useRecoilState(url);
    return (_jsxs(_Fragment, { children: [_jsx(Main, {}), (urls) && _jsx(View, { url: urls, setUrl: setUrl })] }));
}
function View(props) {
    const { url, setUrl } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const lang = localStorage.getItem(Const.LANG_TYPE);
    const [item, setItem] = useState([]);
    let appPath = `?lang=KOR`;
    if (location.pathname !== Const.URL_PRODUCTS) {
        appPath = appPath + `&itemClass=${url.depth2.menuName}`;
    }
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/item/list${appPath}`,
        appQuery: {},
        userToken: "",
        watch: appPath,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setItem(data.body);
            }
        }
    }, [data]);
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "pcontainer" }, { children: (item) && item.map((val, idx) => {
                var _a;
                return (_jsxs("div", Object.assign({ className: `product ${(idx + 1) % 2 === 0 ? "right" : ""} ` }, { children: [_jsx("img", { src: val.mainImage ? val.mainImage.url : "", alt: "\uC774\uBBF8\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." }), _jsxs("div", Object.assign({ className: "product-info" }, { children: [_jsx("div", Object.assign({ className: "product-title" }, { children: val.title })), _jsx("div", Object.assign({ className: "product-subtitle" }, { children: val.subTitle })), _jsx("div", { className: "product-desc", dangerouslySetInnerHTML: {
                                        __html: DOMPurify.sanitize((_a = val.summary) !== null && _a !== void 0 ? _a : "", {
                                            ALLOWED_TAGS: ["br", "b", "strong", "em", "i", "p", "ul", "ol", "li", "span"],
                                            ALLOWED_ATTR: [],
                                        }),
                                    } }), _jsxs("a", Object.assign({ href: "", className: "product-btn", onClick: (e) => cutil.handleUrl(e, url.depth1, url.depth2, navigate, setUrl, { mode: Const.URL_DETAIL, id: val.itemId }) }, { children: [_jsx("span", { children: "\uC790\uC138\uD788 \uBCF4\uAE30" }), _jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "36", viewBox: "0 0 36 36", fill: "none" }, { children: [_jsx("rect", { x: "36", y: "36", width: "36", height: "36", rx: "18", transform: "rotate(180 36 36)", fill: "#001B8B" }), _jsx("path", { d: "M22.175 17L16.575 11.4L18 10L26 18L18 26L16.575 24.6L22.175 19H10V17H22.175Z", fill: "white" })] }))] }))] }))] }), val.itemId));
            }) })) }));
}
